
import React, { useState, useEffect, useMemo } from 'react';

const Stats = () => {

  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
    const API_URL = process.env.REACT_APP_API_URL; // URL de tu API externa para notificar nuevos clientes
  useEffect(() => {
    const fetchConversations = async () => {
      try {
        const response = await fetch(`${API_URL}/conversations/stats`);
        if (!response.ok) throw new Error('Error al cargar las conversaciones');
        const data = await response.json();
        setConversations(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchConversations();
  }, []);

  const [adMessages, setAdMessages] = useState([]);

useEffect(() => {
  const fetchData = async () => {
    try {
      const [convRes, adRes] = await Promise.all([
        fetch(`${API_URL}/conversations/stats`),
        fetch(`${API_URL}/messages/ad-stats`)
      ]);
      if (!convRes.ok || !adRes.ok) throw new Error('Error al cargar las estadísticas');
      setConversations(await convRes.json());
      setAdMessages(await adRes.json());
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  fetchData();
}, []);


const stats = useMemo(() => {
    if (!conversations.length) return null;

    const isAd = (c) => c.from_ad === true;
    const isUnread = (c) => c.unread_count > 0;
    const isEscalada = (c) => c.mode === 'human';

    // SOLUCIÓN 1: Extraer los primeros 10 caracteres directamente.
    // Como tu BD ya manda la fecha ajustada, extraer "YYYY-MM-DD" del string 
    // es más seguro que pasarlo por new Date() que podría reajustarlo.
    const formatDate = (dateString) => {
      if (!dateString) return '';
      return dateString.toString().substring(0, 10); 
    };

    // Extrae "YYYY-MM" para agrupar por mes.
    const formatMonth = (dateString) => {
      if (!dateString) return '';
      return dateString.toString().substring(0, 7);
    };

    // SOLUCIÓN 2: Obtener la fecha de "hoy" forzando la zona horaria de Bogotá.
    // Usamos 'en-CA' porque nativamente formatea las fechas como YYYY-MM-DD.
    const todayStr = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Bogota',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(new Date());

const createCounter = () => ({
  total: 0, ads: 0, organic: 0, read: 0, unread: 0, escaladas: 0,
  contador: 0 // mensajes con from_ad = 1
});

const updateCounter = (obj, conv) => {
  obj.total++;
  isAd(conv) ? obj.ads++ : obj.organic++;
  isUnread(conv) ? obj.unread++ : obj.read++;
  if (isEscalada(conv)) obj.escaladas++;
};

    const general = createCounter();
    const byUser = {};
    const byDate = {};
    const byMonth = {};

    conversations.forEach(conv => {
      // 1. General
      updateCounter(general, conv);

      // 2. Usuario
      const userId = conv.user_id;
      if (!byUser[userId]) {
        byUser[userId] = { ...createCounter(), name: conv.user_name || 'Desconocido' };
      }
      updateCounter(byUser[userId], conv);

      // 3. Fecha
      const dateKey = formatDate(conv.created_at);
      if (!byDate[dateKey]) {
        byDate[dateKey] = { ...createCounter(), date: dateKey };
      }
      updateCounter(byDate[dateKey], conv);

      // 4. Mes
      const monthKey = formatMonth(conv.created_at);
      if (!byMonth[monthKey]) {
        byMonth[monthKey] = { ...createCounter(), month: monthKey };
      }
      updateCounter(byMonth[monthKey], conv);
    });



    // nuevo codigo de messages ad
    adMessages.forEach(({ date, user_id, contador }) => {
  const n = Number(contador) || 0;
  const monthKey = formatMonth(date);

  general.contador += n;

  if (!byUser[user_id]) byUser[user_id] = { ...createCounter(), name: 'Desconocido' };
  byUser[user_id].contador += n;

  if (!byDate[date]) byDate[date] = { ...createCounter(), date };
  byDate[date].contador += n;

  if (!byMonth[monthKey]) byMonth[monthKey] = { ...createCounter(), month: monthKey };
  byMonth[monthKey].contador += n;
});





    const sortedDates = Object.values(byDate).sort((a, b) => new Date(b.date) - new Date(a.date));
    const sortedMonths = Object.values(byMonth).sort((a, b) => b.month.localeCompare(a.month));
    const todayStats = byDate[todayStr] || createCounter();

    return {
      general,
      today: todayStats,
      users: Object.values(byUser),
      dates: sortedDates,
      months: sortedMonths
    };
}, [conversations, adMessages]);

  if (loading) return <div className="p-4 text-center">Cargando estadísticas...</div>;
  if (error) return <div className="p-4 text-center text-red-500">Error: {error}</div>;
  if (!stats) return <div className="p-4 text-center">No hay datos disponibles.</div>;

  return (
    <>
    
    <div className="p-6 w-full mx-auto font-sans h-full overflow-y-scroll">
      <h1 className="text-3xl font-bold mb-8">Dashboard de Conversaciones</h1>

      {/* Grid Superior: Generales y Hoy */}
      <div className="card-stat grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 ">
        
        {/* 1. Estadísticas Generales */}
        <div className="bg-white p-6 rounded-lg shadow border border-gray-200">
          <h2 className="text-xl font-semibold mb-4 text-gray-700">1. Histórico Total</h2>
          <div className="flex justify-between items-center text-lg">
            <span className="font-bold text-2xl">{stats.general.total}</span> Total
          </div>
          <div className="mt-4 space-y-2 text-sm border-t pt-4">
            <div className="flex justify-between text-orange-600">
              <span>Contador (Clicks Ads)</span> <span className="font-medium">{stats.general.contador}</span>
            </div>
            <div className="flex justify-between text-blue-600">
              <span>Pauta (Conversaciones)</span> <span className="font-medium">{stats.general.ads}</span>
            </div>
            <div className="flex justify-between text-green-600">
              <span>Orgánico</span> <span className="font-medium">{stats.general.organic}</span>
            </div>
            <div className="flex justify-between text-red-500 mt-2">
              <span>No Leídas</span> <span className="font-medium">{stats.general.unread}</span>
            </div>
            <div className="flex justify-between text-gray-500">
              <span>Leídas</span> <span className="font-medium">{stats.general.read}</span>
            </div>
            <div className="flex justify-between text-purple-600">
              <span>Escaladas</span> <span className="font-medium">{stats.general.escaladas}</span>
            </div>
          </div>
        </div>

        {/* 4. Estadísticas de Hoy */}
        <div className="bg-white p-6 rounded-lg shadow border border-blue-200">
          <h2 className="text-xl font-semibold mb-4 text-blue-800">4. Resumen de Hoy </h2>
          <div className="flex justify-between items-center text-lg">
            <span className="font-bold text-2xl text-blue-900">{stats.today.total}</span> Total
          </div>
          <div className="mt-4 space-y-2 text-sm border-t pt-4">
            <div className="flex justify-between text-orange-600">
              <span>Contador (Clicks)</span> <span className="font-medium">{stats.today.contador}</span>
            </div>
            <div className="flex justify-between text-blue-600">
              <span>Pauta (Conversaciones)</span> <span className="font-medium">{stats.today.ads}</span>
            </div>
            <div className="flex justify-between text-green-600">
              <span>Orgánico</span> <span className="font-medium">{stats.today.organic}</span>
            </div>
            <div className="flex justify-between text-red-500 mt-2">
              <span>No Leídas</span> <span className="font-medium">{stats.today.unread}</span>
            </div>
            <div className="flex justify-between text-gray-500">
              <span>Leídas</span> <span className="font-medium">{stats.today.read}</span>
            </div>
            <div className="flex justify-between text-purple-600">
              <span>Escaladas</span> <span className="font-medium">{stats.today.escaladas}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="card-stat grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* 2. Estadísticas por Usuario */}
        <div className="bg-white rounded-lg shadow overflow-hidden border border-gray-200">
          <h2 className="text-xl font-semibold p-4 bg-gray-50 border-b">2. Rendimiento por Usuario</h2>
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead className="bg-gray-100">
                <tr>
                  <th className="p-3">Usuario</th>
                  <th className="p-3 text-center">Conversaciones Nuevas</th>
                  <th className="p-3 text-center">Contador Clicks</th>
                  <th className="p-3 text-center">Pauta</th>
                  <th className="p-3 text-center">Orgánico</th>
                  <th className="p-3 text-center">No Leídos</th>
                  <th className="p-3 text-center">Leídos</th>
                  <th className="p-3 text-center">Escaladas</th>
                </tr>
              </thead>
              <tbody>
                {stats.users.map((user, idx) => (
                  <tr key={idx} className="border-b hover:bg-gray-50">
                    <td className="p-3 font-medium">{user.name}</td>
                    <td className="p-3 text-center font-bold">{user.total}</td>
                    <td className="p-3 text-center font-bold">{user.contador}</td>
                    <td className="p-3 text-center text-blue-600">{user.ads}</td>
                    <td className="p-3 text-center text-green-600">{user.organic}</td>
                    <td className="p-3 text-center text-red-500">{user.unread}</td>
                    <td className="p-3 text-center text-gray-500">{user.read}</td>
                    <td className="p-3 text-center text-purple-600">{user.escaladas}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* 3. Estadísticas por Día */}
        <div className="bg-white rounded-lg shadow overflow-hidden border border-gray-200">
          <h2 className="text-xl font-semibold p-4 bg-gray-50 border-b">3. Histórico por Día</h2>
          <div className="overflow-x-auto max-h-[400px] overflow-y-auto">
            <table className="w-full text-left text-sm">
              <thead className="bg-gray-100 sticky top-0">
                <tr>
                  <th className="p-3">Fecha</th>
                  <th className="p-3 text-center">Conversaciones Nuevas</th>
                  <th className="p-3 text-center">Contador Clicks</th>
                  <th className="p-3 text-center">Pauta</th>
                  <th className="p-3 text-center">Orgánico</th>
                  <th className="p-3 text-center">No Leídos</th>
                  <th className="p-3 text-center">Leídos</th>
                  <th className="p-3 text-center">Escaladas</th>
                </tr>
              </thead>
              <tbody>
                {stats.dates.map((day, idx) => (
                  <tr key={idx} className="border-b hover:bg-gray-50">
                    <td className="p-3 font-medium">{day.date}</td>
                    <td className="p-3 text-center font-bold">{day.total}</td>
                    <td className="p-3 text-center font-bold">{day.contador}</td>
                    <td className="p-3 text-center text-blue-600">{day.ads}</td>
                    <td className="p-3 text-center text-green-600">{day.organic}</td>
                    <td className="p-3 text-center text-red-500">{day.unread}</td>
                    <td className="p-3 text-center text-gray-500">{day.read}</td>
                    <td className="p-3 text-center text-purple-600">{day.escaladas}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* 5. Estadísticas por Mes */}
        <div className="card-stat bg-white rounded-lg shadow overflow-hidden border border-gray-200 lg:col-span-2" >
          <h2 className="text-xl font-semibold p-4 bg-gray-50 border-b">5. Histórico por Mes</h2>
          <div className="overflow-x-auto max-h-[400px] overflow-y-auto">
            <table className="w-full text-left text-sm">
              <thead className="bg-gray-100 sticky top-0">
                <tr>
                  <th className="p-3">Mes</th>
                  <th className="p-3 text-center">Conversaciones Nuevas</th>
                  <th className="p-3 text-center">Contador Clicks</th>
                  <th className="p-3 text-center">Pauta</th>
                  <th className="p-3 text-center">Orgánico</th>
                  <th className="p-3 text-center">No Leídos</th>
                  <th className="p-3 text-center">Leídos</th>
                  <th className="p-3 text-center">Escaladas</th>
                </tr>
              </thead>
              <tbody>
                {stats.months.map((m, idx) => (
                  <tr key={idx} className="border-b hover:bg-gray-50">
                    <td className="p-3 font-medium">{m.month}</td>
                    <td className="p-3 text-center font-bold">{m.total}</td>
                    <td className="p-3 text-center font-bold">{m.contador}</td>
                    <td className="p-3 text-center text-blue-600">{m.ads}</td>
                    <td className="p-3 text-center text-green-600">{m.organic}</td>
                    <td className="p-3 text-center text-red-500">{m.unread}</td>
                    <td className="p-3 text-center text-gray-500">{m.read}</td>
                    <td className="p-3 text-center text-purple-600">{m.escaladas}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};



export default Stats;